import { render, staticRenderFns } from "./investPerformance.vue?vue&type=template&id=96b1275a&scoped=true&"
import script from "./investPerformance.vue?vue&type=script&lang=tsx&"
export * from "./investPerformance.vue?vue&type=script&lang=tsx&"
import style0 from "./investPerformance.vue?vue&type=style&index=0&id=96b1275a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b1275a",
  null
  
)

export default component.exports